import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { SlButtonGroup, SlButton } from '@shoelace-style/shoelace/dist/react'
import { useTranslation } from 'contexts/Localization'

const AppNavTabs = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const activeIndex = location.pathname.includes('/liquidity') ? 1 : 0

  return (
    <SlButtonGroup>
      <Link to="/swap">
        <SlButton size="small" variant={activeIndex === 0 ? 'primary' : 'default'}>
          {t('Swap')}
        </SlButton>
      </Link>
      <Link to="/liquidity">
        <SlButton size="small" variant={activeIndex === 1 ? 'primary' : 'default'}>
          {t('Liquidity')}
        </SlButton>
      </Link>
    </SlButtonGroup>
  )
}

export default AppNavTabs
